<div id="assetId" class="title_group_info">
  <span class="mr-0"><strong><span i18n="@@assetid-copy.name.content-id">Content ID</span>: </strong>{{assetID}}</span>
  <span>
    <button type="button" class="btn btn-link small_text left_icon_btn" (click)="copyAssetId(assetID)" 
    placement="top" [ngbTooltip] ="tipContent" [autoClose]="false" #copyToClipBorad = "ngbTooltip"
    triggers="manual" (mouseenter)="toolTipOpen()" (mouseleave)="toolTipClose()">
      <span>
        <img class="copy_message" alt="copy" />{{copyMessage}}
      </span>
    </button>
    <ng-template #tipContent>{{copyAssetIdMsg}}</ng-template>
  </span>
  <span #addButton></span>
</div>